import React, { useState, useCallback, useEffect } from "react";

import { useNavigate, useRouteLoaderData, Link } from "react-router-dom";
import Paper from "Components/UI/Paper";

import DeleteDialog from "Components/UI/Dialogs/DeleteDialog";
import useDeleteDialog from "Components/UI/Dialogs/useDeleteDialog";
import usePost from "Hooks/usePost";
import { updateClientAccount } from "API/swesum";

import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { Tab, Tabs } from "@mui/material";
import Box from "@mui/material/Box";
import ClientAccountFormSystem from "Components/Account/ClientAccountFormSystem";
import ClientAccountFormGeneral from "Components/Account/ClientAccountFormGeneral";
import { useClients } from "Context/Clients";
import { usePopupNotificationContext } from "Context/NotificationPopup";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      style={{
        display: value === index ? "block" : "none",
        minHeight: "400px",
      }}
      id={`x-tabpanel-${index}`}
      aria-labelledby={`x-tab-${index}`}
      {...other}
    >
      {<Box>{children}</Box>}
    </div>
  );
}

export default function ClientAccountCard({
  clientAccount,
  invoices,
  clientArticles,
}) {
  const { clients, fetchClients, hasFetchedAll } = useClients();
  const [formData, setFormData] = useState({
    Id: clientAccount.Id,
    ClientId: clientAccount.ClientId,
    InvoiceId: clientAccount.InvoiceId,
    ClientArticleId: clientAccount.ClientArticleId,
    Amount: clientAccount.Amount,
    PayedId: clientAccount.PayedId,
    Createtime: clientAccount.Createtime,
    ParseMessage: clientAccount.ParseMessage,
    ParseStatus: clientAccount.ParseStatus,
    SystemStatus: clientAccount.SystemStatus,
    BookRefId: clientAccount.BookRefId,
  });

  const deleteDialog = useDeleteDialog(false);
  const { openSuccess, openError } = usePopupNotificationContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (!hasFetchedAll) {
      fetchClients();
    }
  }, [clients]);

  const updateClientAccReq = usePost({
    mtnFunc: (body) => {
      return updateClientAccount(clientAccount.Id, body);
    },
    onSuccess: (data) => {
      openSuccess(`Sparat! ${data.ParseMessage && data.ParseMessage} `, 3000);
    },
    onError: () => {
      openError("Ett fel har uppstått", 3000);
    },
  });

  const deleteClientAccReq = usePost({
    mtnFunc: (inputs) => {
      return deleteClientAccReq(clientAccount.Id);
    },
    onSuccess: (data) => {
      navigate("/clientsaccounts");
    },
    onError: () => {
      deleteDialog.close();
      openError("Ett fel har uppstått.", 3000);
    },
  });

  const handleInputChange = useCallback(
    (field, newVal) => {
      setFormData({ ...formData, [field]: newVal });
    },
    [formData]
  );

  const [tabIndex, setTabindex] = useState(0);

  const handleTabSwitch = (event, newValue) => {
    setTabindex(newValue);
  };

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} md={12}>
          <Paper>
            <Typography
              sx={{ marginBottom: "1.0rem" }}
              variant="h5"
              align="left"
            >
              Klientkontokort
            </Typography>
            <Tabs
              value={tabIndex}
              onChange={handleTabSwitch}
              sx={{ marginBottom: "2rem" }}
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="Allmänt" />
              <Tab label="System" />
            </Tabs>

            <TabPanel value={tabIndex} index={0}>
              <ClientAccountFormGeneral
                formData={formData}
                invoices={invoices}
                clients={clients}
                clientArticles={clientArticles}
                handleInputChange={handleInputChange}
              />
            </TabPanel>
            <TabPanel value={tabIndex} index={1}>
              <ClientAccountFormSystem
                formData={formData}
                invoices={invoices}
                clients={clients}
                clientArticles={clientArticles}
                handleInputChange={handleInputChange}
              />
            </TabPanel>

            <Grid
              item
              xs={12}
              md={12}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button onClick={() => navigate(-1)}>Stäng</Button>
              <Button
                onClick={() => updateClientAccReq.post(formData)}
                variant="contained"
                sx={{ ml: 3 }}
              >
                Spara
              </Button>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
      <DeleteDialog
        title={"Ta bort klientkonto"}
        isOpen={deleteDialog.isOpen}
        handleClose={deleteDialog.close}
        handleDelete={() => deleteClientAccReq.post()}
      >
        Klientkontot kommer att tas bort.
      </DeleteDialog>
    </>
  );
}
